module.exports = __webpack_public_path__ + "img/tab_luntan_low.3947fd47.png";